import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/elevated-card-radio/elevated-card-radio.js';
      import {ObcElevatedCardPosition, ObcElevatedCardSize} from '@oicl/openbridge-webcomponents/dist/components/elevated-card/elevated-card.js';

      export interface Props {
     position?: ObcElevatedCardPosition;
     size?: ObcElevatedCardSize;
     graphicBorder?: boolean;
     border?: boolean;
     name?: string;
     value?: string;
     label?: string;
     checked?: boolean;
     disabled?: boolean;
     required?: boolean
   }

      
  
      export type {ObcElevatedCardPosition, ObcElevatedCardSize} from '@oicl/openbridge-webcomponents/dist/components/elevated-card/elevated-card.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcElevatedCardRadio',
  props: {
    position: {},
    size: {},
    graphicBorder: { type: Boolean },
    border: { type: Boolean },
    name: {},
    value: {},
    label: {},
    checked: { type: Boolean },
    disabled: { type: Boolean },
    required: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onChange: (event: CustomEvent<unknown>) => emit('change', event as CustomEvent<unknown>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-elevated-card-radio',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})